import React from "react";
import { MenuItem, Select, InputLabel } from "@mui/material";
import { DynamicFormControl, StyledMenu } from "../../../MUIStyled";
import { HelperTextTypography } from "../Typography/TypographyVariant";

export const CustomDropdownField = ({
  value,
  onChange,
  name,
  label,
  options,
  error,
  variant,
  helperText,
}) => (
  <DynamicFormControl fullWidth variant={variant} error={Boolean(error)}>
    <InputLabel>{label}</InputLabel>
    <Select
      value={value}
      onChange={onChange}
      name={name}
      label={label}
      sx={{ textAlign: "left" }}
      menucomponent={StyledMenu}
    >
      {options.map((option, index) => (
        <MenuItem key={index} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
    {error && <HelperTextTypography>{helperText}</HelperTextTypography>}
  </DynamicFormControl>
);
